import React from 'react';
import styled from 'styled-components';

import Table from 'components/Table';

const YmsData = ({ isLoading, yms }) => {
  return (
    <YmsDataTable
      loading={isLoading}
      dataSource={yms}
      rowKey="dt_datetime"
    >
      <Table.Column type="text" title="Action" dataIndex="action" />
      <Table.Column type="text" title="Container Size" dataIndex="container_size" />
      <Table.Column type="text" title="Weight" dataIndex="weight" />
      <Table.Column type="text" title="Cube" dataIndex="cube" />
      <Table.Column type="text" title="Cartons" dataIndex="cartons" />
      <Table.Column type="text" title="Customer" dataIndex="customer_name" />
      <Table.Column type="text" title="Facility" dataIndex="facility" />
      <Table.Column type="text" title="Imported" dataIndex="imported" render={(imported) => {
        return imported === 1 ? 'Yes' : 'No';
      }} />
      <Table.Column type="text" title="Process Status" dataIndex="process_status" />
      <Table.Column type="text" title="Tag Zone" dataIndex="tag_zone" />
      <Table.Column type="text" title="Tag Zone Group" dataIndex="tag_zone_group" />
      <Table.Column type="text" title="Assigned Zone" dataIndex="assigned_zone" />
      <Table.Column type="text" title="Tag Zone Old" dataIndex="tag_zone_old" />
      <Table.Column type="datetime" title="Added At" dataIndex="date_added" align="right" />
      <Table.Column type="datetime" title="Last Updated At" dataIndex="last_update" align="right" />
      <Table.Column type="datetime" title="Arrival Time" dataIndex="arrival_time" align="right" />
    </YmsDataTable>
  );
};

const YmsDataTable = styled(Table)`
  & .ant-table {
    overflow: auto;
  }
`;

export default YmsData;
